var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{on:{"click":_vm.click}},[_vm._t("default",[_vm._v("請求書発行")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }